module.exports = __webpack_public_path__ + "static/media/target.ccc673f1.svg";